import React from 'react';
import { Button } from './ui/Button';
import { Link } from 'react-router-dom';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-20 overflow-hidden" data-id="element-60">
      {/* Background Elements */}
      <div className="absolute inset-0 z-0 opacity-20" data-id="element-61">
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-yellow-400 rounded-full blur-[120px] -translate-y-1/2 translate-x-1/2" data-id="element-62" />
        <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-white rounded-full blur-[100px] translate-y-1/2 -translate-x-1/2" data-id="element-63" />
      </div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-64">
        <div className="max-w-5xl" data-id="element-65">
          <h2 className="text-yellow-400 font-bold tracking-widest uppercase mb-6 animate-fade-in-up" data-id="element-66">
            Creative Digital Studio
          </h2>

          <h1 className="text-7xl md:text-9xl font-black text-white leading-[0.9] tracking-tighter mb-10" data-id="element-67">
            WE BUILD <br data-id="element-68" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-500" data-id="element-69">
              BOLD
            </span>{' '}
            IDEAS
          </h1>

          <p className="text-xl md:text-2xl text-gray-400 max-w-2xl mb-12 leading-relaxed" data-id="element-70">
            KUJODO is a design-driven studio crafting immersive digital
            experiences for brands that refuse to blend in.
          </p>

          <div className="flex flex-col sm:flex-row gap-6" data-id="element-71">
            <Link to="/work" data-id="element-72">
              <Button icon data-id="element-73">View Projects</Button>
            </Link>
            <Button variant="outline" data-id="element-74">Our Process</Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce" data-id="element-75">
        <div className="w-[1px] h-24 bg-gradient-to-b from-yellow-400 to-transparent" data-id="element-76" />
      </div>
    </section>;
}